module.exports = __webpack_public_path__ + "static/media/icn-car-grey.61457a44.svg";